module.exports = __webpack_public_path__ + "img/pdf-file.155d66c6.png";